'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _env = require('../env');

var location = function location() {
  return typeof (0, _env.env)() !== 'undefined' && (0, _env.env)().location;
};

exports.default = {
  getHost: function getHost() {
    return location() && (0, _env.env)().location.host;
  },
  isFedopsDev: function isFedopsDev() {
    var q = (location() || {}).search || '';
    return q.indexOf('fedops=dev') > -1;
  }
};


//////////////////
// WEBPACK FOOTER
// ../node_modules/fedops-logger/dist/src/app-data/location.js
// module id = 489
// module chunks = 0